import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrHouseRuleCategory.ts
var t = () => e("houseRuleCategory");
//#endregion
export { t as useTrHouseRuleCategory };
